/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Save_Group_ButtonInputs */

const en_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Group`)
};

const fr_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le groupe`)
};

const de_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppe speichern`)
};

const it_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva gruppo`)
};

const ru_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить группу`)
};

const es_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar grupo`)
};

const zh_cn2_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存组`)
};

const ja_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを保存`)
};

const hi_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह को सहेजें`)
};

const pt_pt2_team_manager_save_group_button = /** @type {(inputs: Team_Manager_Save_Group_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar grupo`)
};

/**
* | output |
* | --- |
* | "Save Group" |
*
* @param {Team_Manager_Save_Group_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_save_group_button = /** @type {((inputs?: Team_Manager_Save_Group_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Save_Group_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_save_group_button(inputs)
	if (locale === "de") return de_team_manager_save_group_button(inputs)
	if (locale === "it") return it_team_manager_save_group_button(inputs)
	if (locale === "ru") return ru_team_manager_save_group_button(inputs)
	if (locale === "es") return es_team_manager_save_group_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_save_group_button(inputs)
	if (locale === "ja") return ja_team_manager_save_group_button(inputs)
	if (locale === "hi") return hi_team_manager_save_group_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_save_group_button(inputs)
	return en_team_manager_save_group_button(inputs)
});